module.exports = __webpack_public_path__ + "766197b3b10ff6719d3bdd4590ee61ce.svg";